import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { UUID } from '@/types';

export const permissionApi = createApi({
  reducerPath: 'permissionDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    credentials: 'same-origin',
  }),
  endpoints: (builder) => ({
    getUserPerms: builder.query<string, { datasourceId: UUID }>({
      query: ({ datasourceId }) =>
        `datasources/${datasourceId}/permissions/user`,
    }),
  }),
});

export const { useGetUserPermsQuery } = permissionApi;
